<div class="flex">
  @if (gotData | async) {
    <app-epost-config
      [ePostConfig]="data"
      (requestSmsClicked)="requestSmsClicked$.emit()"
      (healthCheckClicked)="healthCheckClicked$.emit()"
      (formChange)="formChangeEvent$.emit($event)"
    />
  }
</div>
